const isValidEmailDomain = (email: string, domainNames: string): boolean => {
    if (!email || !domainNames || domainNames.trim() === "") {
        return true;
    }

    const allowedDomains = domainNames
        .split(",")
        .map((domain) => domain?.trim()?.toLowerCase());

    const emailDomain = email?.split("@")[1]?.toLowerCase();

    return allowedDomains.includes(emailDomain);
}

export default isValidEmailDomain;